import Box from '@mui/material/Box';
import { HistoryButton } from './HistoryButton';
import { SectionLabel } from './SectionLabel';

interface CardHeaderProps {
  title: string;
  onOpenHistory: () => void;
}

/** Antetul comun al cardurilor: eticheta secțiunii + butonul de istoric. */
export function CardHeader({ title, onOpenHistory }: CardHeaderProps) {
  return (
    <Box
      sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '12px' }}
    >
      <SectionLabel>{title}</SectionLabel>
      <HistoryButton onClick={onOpenHistory} title="Istoric detaliat" />
    </Box>
  );
}
